import React, { useState, useContext } from "react";
import { EligibilityContext } from "../../contexts/EligibilityContext";

const CriteriaText = ({ criteria, register, errors }) => {
  const context = useContext(EligibilityContext);
  const [response, setResponse] = useState("");

  return (
    <fieldset className="u-mb4">
      <label htmlFor={`${criteria.name}`}>
        {criteria.criteria}

        {errors[criteria.name] && errors[criteria.name].type === "required" && (
          <span data-validate="error">Please provide a response.</span>
        )}
      </label>
      <input
        type="text"
        id={criteria.name}
        onChange={(event) => setResponse(event.target.value)}
      />
      <input
        type="hidden"
        name={criteria.name}
        ref={register({ required: true })}
        readOnly={true}
        onChange={null} // disable controlled/uncontrolled warning
        value={
          response
            ? JSON.stringify({
                criteria: criteria.criteria,
                fundId: context.state.diseaseFund.fundId,
                answerType: criteria.answerType,
                response: response,
                id: criteria.id,
                criteriaMetaDataName: criteria.criteriaMetaDataName,
              })
            : "" // if no response, set value to empty string for validation
        }
      />
    </fieldset>
  );
};

export default CriteriaText;
